import styled from "styled-components";
import Lottie from "lottie-react";

export const CenterAreaOne = styled.div`
  flex: 2;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  display: flex;
`;

export const CenterAreaTwo = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding-bottom: 16px;
`;

export const LottieAnimation = styled(Lottie)`
  height: 170px;
  width: 170px;
`;

export const Label = styled.img`
  height: 50px;
  width: 94%;
`;

export const LogoDiv = styled.div`
  flex-direction: row;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 30px;
  margin-top: 20px;
  margin-bottom: 20px;
`;
export const Logo = styled.img`
  height: 40px;
  margin-bottom: ${(props) => (props.mobileWidth === false ? "10px" : "20px")};
  margin-top: 10px;
`;

export const LabelContent = styled.p`
  position: absolute;
  font-weight: 900;
  color: #ec613e;
  text-align: center;
  width: 300px;
`;

export const Header = styled.span`
  text-align: center;
  color: #f8c933;
  font-size: 16px;
  margin-top: 20px;
  letter-spacing: 1px;
`;

export const Bottom = styled.span`
  padding-left: 30px;
  padding-right: 30px;
  color: #f8c933;
  font-size: 13px;
  letter-spacing: 1px;
`;

export const SubTitle = styled.div`
  font-size: 14px;
  color: #f8c933;
`;

export const BeginTitle = styled.img`
  width: ${(props) => (props.isEnglish === true ? "300px" : "220px")};
  height: ${(props) => (props.isEnglish === false ? "40px" : "auto")};
  margin-top: 20px;
`;

export const LottieAnimationDiv = styled.div`
  display: flex;
  justify-content: center;
`;
export const P = styled.p`
  font-size: 10px;
  margin-top: 0px;
  color: #f8c933;
`;
